import api from '../../../api';

export interface SubscriptionRenewalStatus {
  hasActiveRenewal: boolean;
  renewals: {
    orderId: number;
    billingPeriodEndAt: string;
    renewalStatus: string;
  }[];
}

export const getSubscriptionRenewalStatus = async (): Promise<SubscriptionRenewalStatus> => {
  const response = await api.get('/domain/subscription-renewal-status');
  return response.payload;
};

export const createSubscriptionRenewalCheckout = async (
  orderId: number,
): Promise<{ checkoutUrl: string }> => {
  const response = await api.post('/domain/subscription-renewal-checkout', { orderId });
  return response.payload;
};
